var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-card',[_c('alter-form',{ref:"alterForm",attrs:{"modifyData":_vm.modifyData,"formData":_vm.formData,"collapseLength":_vm.collapseLength},on:{"formSubmit":_vm.formSubmit,"handleChange":_vm.handleChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }